import React, { Component } from "react";
import {
  // CustomInput,
  // Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import { Uploader } from "rsuite";
import { Formik, Field, Form } from "formik";

// import Select from "react-select";
// import CustomSelectInput from "../../../../../../components/common/CustomSelectInput";
import IntlMessages from "../../../../../../helpers/IntlMessages";

import { Product, UploaderImage } from "../../../../../../api/Api";
import { APIClient } from "../../../../../../api/_api";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";

export default class EditConstant extends Component {
  state = {
    editorState: EditorState.createWithContent(
      ContentState.createFromBlockArray(
        // convertFromHTML(this.props.product.content)
        convertFromHTML(this.props.product.translates.find(x => x.langCode === 'fa').description)
      )
    ),
    loading: false,
    pdfLoading: false,
    langs: [],
    pdf: '',
    initialValues: {
      ...this.props.product.translates.find(x => x.langCode === 'fa'),
      price: Number(this.props.product.price)
    }
  };

  handleChangeLang = async (event) => {
    // console.log('log:', this.props.product.translates.find(x => x.langCode === event.target.value))
    // let initialValues = {
    //   ...this.props.product.translates.find(x => x.langCode === event.target.value),
    //   price: this.props.product.price
    // }
    // console.log('log:', initialValues)
    // if (Object.keys(initialValues).length < 2)  initialValues = {langCode: event.target.value, name: '', description: '', pdf: '', ...initialValues}
    
    // this.setState({
    //   initialValues: initialValues,
    //   pdf: initialValues.pdfUrl ?? ''
    // })
    let initialValues = this.props.product.translates.find(x => x.langCode === event.target.value)

    if (initialValues) {
      const editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(initialValues.description)
        )
      )
      this.setState({
        editorState,
        initialValues,
        price: Number(this.props.product.price)
      });
    }
    else {
      initialValues = {langCode: event.target.value, name: '', description: '', pdf: '', price: 0, ...initialValues}
      const editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML('')
        )
      )

      this.setState({
        editorState,
        initialValues
      });
    }
  }

  handleChangePdf = async ({ target, ...e }) => {
    this.setState({ pdfLoading: true });
    try {
      const { data } = await UploaderImage.addPDF(e[0].blobFile);
      let imagesId = '';
      data.data.forEach((element) => {
        imagesId = element.url
      });

      this.setState({ pdf: imagesId, pdfLoading: false});
    } catch (error) {
      this.setState({ pdfLoading: false});
    }
  };

  handleSubmit = async (values, { resetForm, setSubmitting, setValues }) => {
    this.setState({ loading: true });
    try {
      if (values.langCode === undefined) return 

      APIClient.defaults.headers["lang"] = values.langCode
      let newValues = {
        price: Number(this.props.product.price),
        ...values,
        description: draftToHtml(
          convertToRaw(this.state.editorState.getCurrentContent())
        ),
        pdf: this.state.pdf,
      };


      await Product.editProduct(newValues, this.props.product.id);

      //closing addNew Component
      this.props.toggleModal();

      //fetching data from dataBase
      this.props.dataListRender();

      // if (!this.state.isNew) {
      //   Swal.close();
      // }
      const editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML('')
        )
      )

      this.setState({
        editorState,
      });
      resetForm();
    } catch (error) {
      console.error(error);
      // toast(error.response.data.message);
    }
    this.setState({ loading: false });
  };
  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  render() {
    const { editorState } = this.state;
    return (
      <>
        <Modal
          onOpened={() => this.handleChangeLang({target: {value: 'fa'}})}
          isOpen={this.props.modalOpen}
          toggle={this.props.toggleModal}
          wrapClassName="modal-right"
          backdrop="static"
        >
          {this.state.loading ? <div className="loading" /> : ""}
          <ModalHeader toggle={this.props.toggleModal}>
            <IntlMessages id="pages.edit-new-modal-Product" />
          </ModalHeader>
          <ModalBody>
            <Formik
              enableReinitialize
              initialValues={this.state.initialValues}
              // validationSchema={this.ValidationSchema}
              onSubmit={this.handleSubmit}
            >
              {(props) => (
                <Form className="form" onSubmitCapture={props.handleSubmit}>
                   <Label className="mt-4">زبان</Label>
                  <Field
                    name="lang"
                    placeholder="زبان"
                    className="form-control"
                    component="select"
                    onChange={this.handleChangeLang}
                  >
                    {
                      this.props.langs.map((item) => {
                        return (
                          <option value={item.langCode}>{item.name}</option>
                        )
                      })
                    }
                  </Field>

                  <Label className="mt-4">
                    <IntlMessages id="title-moti" />
                  </Label>
                  <Field
                    name="name"
                    placeholder="عنوان"
                    className="form-control"
                    type="text"
                    required
                  />
                  <Label className="mt-4">
                    <IntlMessages id="pages.description" />
                  </Label>
                  <div>
                    <Editor
                        editorState={editorState}
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor"
                        onEditorStateChange={this.onEditorStateChange}
                      />
                    <Field
                      style={{display: 'none'}}
                      name="description"
                      placeholder="توضیحات"
                      className="form-control"
                      type="text"
                      // required
                    />
                  </div>
                  
                  <Label className="mt-4">
                    <IntlMessages id="pages.price" />
                  </Label>
                  <Field
                    name="price"
                    placeholder="2000"
                    className="form-control text-left"
                    type="number"
                    required
                  />

                  <div className="mb-3" style={{ position: "relative" }}>
                    <Label className="mt-4">
                      PDF File
                    </Label>
                    {
                      (this.state.initialValues && this.state.initialValues.pdfUrl) || this.state.pdf ? 
                        <Button
                          className="d-block"
                          color="info"
                          onClick={() => {
                            const initialValues = this.state.initialValues
                            initialValues.pdfUrl = ''

                            this.setState({ initialValues: initialValues, pdf: '' });
                          }}
                        >
                          حذف کاتالوگ
                        </Button>
                      :
                        <>
                          <Uploader
                            style={{ height: "20px", marginBottom: "30px" }}
                            name="pdf"
                            placeholder="PDF"
                            className="custom-file-input"
                            type="file"
                            onChange={(e) => this.handleChangePdf(e)}
                            accept="application/pdf"
                          />

                          <button
                            style={{
                              position: "absolute",
                              top: "50px",
                              left: "1px",
                              width: "325px",
                              background: "white",
                              height: "45px",
                            }}
                            type="button"
                          >
                            اپلود کاتالوگ
                          </button>
                      </>
                    }
                  </div>

                  <ModalFooter>
                    {this.state.pdfLoading ? <div className="loading" /> : 
                    <>
                      <Button
                        className="ml-1 mr-1"
                        color="secondary"
                        outline
                        onClick={this.props.toggleModal}
                        >
                        <IntlMessages id="pages.cancel" />
                      </Button>
                      <Button color="primary" type="submit">
                        <IntlMessages id="pages.submit" />
                      </Button>
                    </>
                    }
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>

          {/* <ModalHeader toggle={toggleModal}>
          <IntlMessages id="pages.add-new-modal-title" />
        </ModalHeader>
        <ModalBody>
          <Label className="mt-4">
            <IntlMessages id="pages.name" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.price" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.duration" />
          </Label>
          <Input />
          <Label className="mt-4">
            <IntlMessages id="pages.category" />
          </Label>
          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            name="form-field-name"
            options={categories}
          />
          <Label className="mt-4">
            <IntlMessages id="pages.description" />
          </Label>
          <Input type="textarea" name="text" id="exampleText" />
          <Label className="mt-4">
            <IntlMessages id="pages.status" />
          </Label>
          <CustomInput
            type="radio"
            id="exCustomRadio"
            name="customRadio"
            label="ON HOLD"
          />
          <CustomInput
            type="radio"
            id="exCustomRadio2"
            name="customRadio"
            label="PROCESSED"
          />
        </ModalBody> */}
          {/* <ModalFooter>
          <Button color="secondary" outline onClick={toggleModal}>
            <IntlMessages id="pages.cancel" />
          </Button>
          <Button color="primary" onClick={toggleModal}>
            <IntlMessages id="pages.submit" />
          </Button>{" "}
        </ModalFooter> */}
        </Modal>
      </>
    );
  }
}
